<template>
  <div class="drugType">
    <Search :title="chame" :attent="num + '项需关注'" :total="'共计'+ total + '种药物'">
      <div v-if="gdb3">
        <van-cell v-for="(item,index) in drugTypeData" :key="index" :title="item.name" is-link @click="$router.push({path: '/drugInfo/' + item.id})">
          <template slot="label">
            <span class="need" v-if="item.conclusion !== '无需关注'">关注方面：<span>{{ item.conclusion }}</span></span>
            <span v-else>无需关注</span>
          </template>
        </van-cell>
      </div>
      <div v-if="gdb2">
        <van-cell v-for="(item,index) in drugTypeData" :key="index" :title="item.chname" is-link @click="$router.push({path: '/drugInfo/' + item.itemid})">
          <template slot="label">
            <span v-if="item.age_range">{{'('+(item.age_range)+'岁)'}}</span>
            <div v-if="parseInt(item.tag)">
              <span class="need">关注方面：<span>{{ item.conclusion }}</span></span>
            </div>
            <div v-else>
              <span>无需关注</span>
            </div>
          </template>
        </van-cell>
      </div>
    </Search>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'drugType',
  data () {
    return {
      gdb3: false,
      gdb2: false,
      chame: this.$route.params.id,
      num: '',
      total: '',
      drugTypeData: []
    }
  },
  methods: {
    getDrugItems () {
      this.util.get(this.api.drug_items + '?system=' + this.chame, '', (success) => {
        this.drugTypeData = success.items
        this.num = success.quantity.attention
        this.total = success.quantity.total
        this.util.setLS('paginationData', success.items)
      })
    },
    // gdb2
    getDrugSystemInfo () {
      this.util.get1(this.api.drugSystemInfo + '?system=' + this.chame, '', (success) => {
        this.drugTypeData = success.list
        this.num = success.follow_num
        this.total = success.sum
      })
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getDrugItems()
    } else {
      this.gdb2 = true
      this.getDrugSystemInfo()
    }
  },
  components: {
    Search
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .drugType {
    .need {
      span {
        color: #007aff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/drug/drugType.vue